import Phaser from 'phaser';

const BG_OUTER = 0x312e81;
const BG_INNER = 0x4c1d95;
const EDGE_CYAN = 0x22d3ee;
const WEB_LINE = 0xfbcfe8;
const SPIDER_PINK = 0xf472b6;
const SPIDER_HIGHLIGHT = 0xfce7f3;
const STROKE = 0x0a0f1f;

export function drawGhostWeb(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  g.lineStyle(Math.max(1, Math.floor(stroke * 0.6)), EDGE_CYAN, 0.85);
  g.strokeCircle(0, 0, r * 0.86);

  g.lineStyle(Math.max(1, Math.floor(stroke * 0.5)), WEB_LINE, 0.75);
  for (let i = 0; i < 6; i++) {
    const a = (i / 6) * Math.PI * 2;
    g.beginPath();
    g.moveTo(0, 0);
    g.lineTo(Math.cos(a) * r * 0.82, Math.sin(a) * r * 0.82);
    g.strokePath();
  }
  for (let ring = 1; ring <= 2; ring++) {
    const rr = (r * 0.82 * ring) / 3;
    g.beginPath();
    for (let i = 0; i < 7; i++) {
      const a = (i / 6) * Math.PI * 2;
      const x = Math.cos(a) * rr;
      const y = Math.sin(a) * rr;
      if (i === 0) g.moveTo(x, y);
      else g.lineTo(x, y);
    }
    g.strokePath();
  }

  const bodyR = r * 0.3;
  g.fillStyle(SPIDER_PINK, 1);
  g.fillCircle(0, 0, bodyR);
  g.fillCircle(0, -bodyR * 0.65, bodyR * 0.55);

  g.lineStyle(Math.max(1, Math.floor(stroke * 0.7)), SPIDER_PINK, 1);
  for (let side = -1; side <= 1; side += 2) {
    for (let i = 0; i < 4; i++) {
      const legLen = bodyR * (0.9 + i * 0.15);
      const angleOffset = -0.5 + i * 0.4;
      const joint1 = {
        x: side * bodyR * 0.6,
        y: bodyR * 0.1 + angleOffset * bodyR * 0.3,
      };
      const joint2 = {
        x: joint1.x + side * legLen * 0.5,
        y: joint1.y + angleOffset * legLen * 0.3,
      };
      const tip = {
        x: joint2.x + side * legLen * 0.4,
        y: joint2.y + angleOffset * legLen * 0.4 + 2,
      };
      g.beginPath();
      g.moveTo(joint1.x, joint1.y);
      g.lineTo(joint2.x, joint2.y);
      g.lineTo(tip.x, tip.y);
      g.strokePath();
    }
  }

  g.fillStyle(SPIDER_HIGHLIGHT, 0.85);
  g.fillCircle(-bodyR * 0.3, -bodyR * 0.2, bodyR * 0.25);
}
